const CDN_DOMAIN = 'https://cdn.123wonder.cn';
const COS_DOMAIN = 'https://123wonder-1409012743.cos.ap-hongkong.myqcloud.com';

export const getMediaUrl = (path) => {
  if (!path) return path;
  
  if (path.startsWith('http')) {
    if (path.startsWith(COS_DOMAIN)) {
      const cdnUrl = path.replace(COS_DOMAIN, CDN_DOMAIN);
      try {
        const url = new URL(cdnUrl);
        url.pathname = encodeURI(decodeURIComponent(url.pathname));
        return url.toString();
      } catch (e) {
        return cdnUrl;
      }
    }
    return path;
  }
  
  // In development, use relative path so proxy works
  // In production, you might want to use the full backend URL
  return path;
};

export default { getMediaUrl };
